import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    closedMsg: {
        color: theme.palette.amano.closed.main,
        position: "absolute",
        bottom: 32,
        right: 6,
        fontWeight: "bold",
        '&.full': {
            bottom: 48,
            color: theme.palette.warning.dark,
        }
    }
}));
